import { create } from 'zustand';

const useStore = create((set) => ({
  // State
  user: null,
  darkMode: true,
  isOfficeDay: false, // Default context
  userProfile: {
    name: '',
    preferredName: '',
    initials: '',
    age: null,
    weight: null, // in lbs, for protein calculation
    lifeStage: null, // 'reproductive' (18-44) | 'perimenopause' (45-55) | 'menopause' (55+) | 'postmenopause' (60+)
    avatar: '🥚', // Everyone starts with an egg that grows into a Kitsune
    hasCompletedOnboarding: false,
    disclaimerAccepted: false
  },
  isHydrated: false, // Prevents saving default data over existing data
  currentTime: new Date(), // Global current time
  spiritAnimalScore: 0, // Balance score (0-100) for avatar growth
  currentView: 'dashboard', // Current view: 'dashboard' | 'food' | 'exercise' | 'learn'

  // Actions
  setUser: (user) => set({ user }),
  setDarkMode: (darkMode) => set({ darkMode }),
  toggleOfficeDay: () => set((state) => ({ isOfficeDay: !state.isOfficeDay })),
  setUserProfile: (userProfile) => set({ userProfile }),
  setIsHydrated: (isHydrated) => set({ isHydrated }),
  setCurrentTime: (time) => set({ currentTime: time }), // Action to update current time
  setSpiritAnimalScore: (score) => set({ spiritAnimalScore: typeof score === 'function' ? score(useStore.getState().spiritAnimalScore) : score }),
  setCurrentView: (view) => set({ currentView: view }), // Action to change view
}));

export default useStore;
